import { render, staticRenderFns } from "./RawmaterialStockReport.vue?vue&type=template&id=bf0b970a&"
import script from "./RawmaterialStockReport.vue?vue&type=script&lang=js&"
export * from "./RawmaterialStockReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RawmaterialStockReport.vue"
export default component.exports